/**
 * Normaliza uma string para kebab-case (ASCII-only).
 * Exemplos:
 * - "Módulo Básico 1!" → "modulo-basico-1"
 * - "Advanced Grammar" → "advanced-grammar"
 * - "Test@#$%^&*()" → "test"
 */
export function toKebabCase(input: string | null | undefined): string {
  if (!input || typeof input !== 'string') {
    return '';
  }

  // Remove acentos e caracteres especiais, converte para minúsculas
  const normalized = removeDiacritics(input.toLowerCase());
  
  // Remove caracteres não-alfanuméricos, mantém apenas letras, números e espaços
  const cleaned = normalized.replace(/[^a-z0-9\s]/g, '');
  
  // Substitui espaços e hífens múltiplos por hífen único
  const kebabed = cleaned.replace(/[\s\-]+/g, '-');
  
  // Remove hífens no início e fim
  return kebabed.replace(/^-+|-+$/g, '');
}

/**
 * Remove acentos e diacríticos de uma string.
 */
function removeDiacritics(text: string): string {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

/**
 * Valida se uma string está em formato kebab-case válido.
 */
export function isValidKebabCase(input: string | null | undefined): boolean {
  if (!input || typeof input !== 'string') {
    return false;
  }

  // Regex para kebab-case: apenas letras minúsculas, números e hífens
  // Não pode começar ou terminar com hífen
  // Não pode ter hífens consecutivos
  return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(input);
}

/**
 * Gera um internal name baseado no nome do módulo.
 * Se o nome contém um número, usa "module-{número}".
 * Caso contrário, usa "module-{sequência}".
 */
export function generateInternalName(name: string, sequence: number = 1): string {
  if (!name) {
    return `module-${sequence}`;
  }

  // Tenta extrair número do nome (ex: "Módulo 5" → "5")
  const numberMatch = name.match(/(\d+)/);
  if (numberMatch) {
    return `module-${numberMatch[1]}`;
  }

  // Se não há número, usa sequência
  return `module-${sequence}`;
}
